export const toDataTest = (value: string): string =>
    value.replace(/__/g, "").replace(".", "-").replace("_", "-").replace(/\s+/g, "-").toLowerCase();
